import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createRecipe, updateRecipe, clearMessages as clearRecipeMessages } from '../../../redux/slices/admin/recipesSlice';
import recipeIcon from '../../../images/icon-check-recipe-ing.svg';
import api from '../../../api';

const RecipeModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        recipe_name: '',
        protein: '',
        fat: '',
        carb: '',
        instructions: '',
        meal_picture: null,
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [ingredientSuggestions, setIngredientSuggestions] = useState([]);
    const [selectedIngredients, setSelectedIngredients] = useState([]);

    const successMessage = useSelector((state) => state.admin_recipes?.successMessage);
    const errorMessage = useSelector((state) => state.admin_recipes?.error);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                recipe_name: initialData.meal_name || '',
                protein: initialData.protein || '',
                fat: initialData.fat || '',
                carb: initialData.carb || '',
                instructions: initialData.instructions || '',
                meal_picture: null,
            });

            if (initialData.ingredients && initialData.ingredients !='' && initialData.ingredients!=null && initialData.ingredients!='null' &&
               initialData.ingredients != undefined && initialData.ingredients != 'undefined') {
                 setSelectedIngredients(initialData.ingredients);
            } else {
                setSelectedIngredients([]);
            }
            
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleFileChange = (event) => {
        setFormData((prevData) => ({ ...prevData, meal_picture: event.target.files[0] }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            data.append(key, value);
        });
        data.append('ingredients', JSON.stringify(selectedIngredients));

        if (isEditMode) {
            data.id = initialData.id;
            await dispatch(updateRecipe(data));
        } else {
            await dispatch(createRecipe(data));
        }
    };

    const handleClose = () => {
        dispatch(clearRecipeMessages());
        setFormData({
            recipe_name: '',
            protein: '',
            fat: '',
            carb: '',
            instructions: '',
            meal_picture: null,
        });
        setSelectedIngredients([]);
        closeModal();
    };

    // Handle search input change
    const handleSearchChange = async (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value.trim()) {
            try {
                const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/nutritions-list-minimal`, {
                    page: 1,
                    searchTerm: value
                });

                if (response.data.success) {
                    setIngredientSuggestions(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching ingredients:', error);
            }
        } else {
            setIngredientSuggestions([]);
        }
    };

    const handleIngredientSelect = (ingredient) => {
        const newIngredient = { ...ingredient, quantity: 1 }; // Create a new object with quantity
        setSelectedIngredients((prev) => [...prev, newIngredient]); // Update state with the new object
        setIngredientSuggestions([]);
        setSearchTerm('');
    };
    
    const handleRemoveIngredient = (ingredientId) => {
        setSelectedIngredients((prev) =>
            prev.filter((ingredient) => ingredient.id !== ingredientId)
        );
    };

    const fileInputRef = useRef(null);
    useEffect(() => {
    if (formData.meal_picture === null && fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }, [formData.meal_picture]);

    if (!isOpen) return null;

    return (
        <div className="modal fade show" id="modalNutritionRecipes" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="createBackdropLabel" aria-modal="true" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                    {!successMessage && (
                        <h1 className="modal-title" id="createBackdropLabel">{isEditMode ? 'Edit Recipe' : 'Create Recipe'}</h1>
                    )}
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>

                    {successMessage ? (
                        <div className="modal-body">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <div className="alert alert-success text-center">
                                        {successMessage}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="recipe_name"
                                        placeholder="Recipe Name"
                                        className="form-control form-control-lg"
                                        value={formData.recipe_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4">
                                    <input
                                        type="text"
                                        name="protein"
                                        placeholder="Protein"
                                        className="form-control form-control-lg"
                                        value={formData.protein}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-sm-6 col-md-4">
                                    <input
                                        type="text"
                                        name="fat"
                                        placeholder="Fats"
                                        className="form-control form-control-lg"
                                        value={formData.fat}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        name="carb"
                                        placeholder="Carbs"
                                        className="form-control form-control-lg"
                                        value={formData.carb}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-7">
                                    <input
                                        type="text"
                                        placeholder="Type to search ingredients"
                                        className="form-control form-control-lg"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <ul className="ul-recipe-ingd">
                                        {ingredientSuggestions.map((ingredient) => (
                                            <li key={ingredient.id} onClick={() => handleIngredientSelect(ingredient)}>
                                                {ingredient.ingredient_name}
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="selected-ingredients">
                                        <table className="ingredients-table">
                                            <tbody>
                                                {selectedIngredients.map((ingredient) => (
                                                    <tr className="ingredient-row" key={ingredient.id}>
                                                        <td className="ingredient-icon-cell">
                                                            <img src={recipeIcon} alt="icon" className="ingredient-icon" />
                                                            <span className="ingredient-title">{ingredient.ingredient_name}</span>
                                                        </td>
                                                        <td className="delete-icon-cell">
                                                            <span className="delete-icon" onClick={() => handleRemoveIngredient(ingredient.id)}>✖</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <textarea
                                        name="instructions"
                                        placeholder="Instructions"
                                        className="form-control h-100 form-control-choose"
                                        rows="3"
                                        value={formData.instructions}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label>Picture</label>
                                    <div className="position-relative">
                                        <input
                                            type="file"
                                            name="meal_picture"
                                            className="form-control form-control-lg form-control-choose"
                                            onChange={handleFileChange}
                                            ref={fileInputRef}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                </div>

                                <div className="col-md-12">
                                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecipeModal;